import {Box, Typography} from "@mui/material";

function MetaList({items}) {
    return (
        <Box component="ul" sx={{listStyle: 'none', p: 0, m: 0, mt: 2}}>
            {items.map((item, i) => (
                <Box
                    component="li"
                    key={i}
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 1.25,
                        mb: 0.75,
                    }}
                >
                    <Box component="span" sx={{fontSize: '1.1rem', lineHeight: 1.5, flexShrink: 0}}>
                        {item.icon}
                    </Box>
                    <Typography component="span" sx={{lineHeight: 1.5}}>
                        {item.text}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}

export default MetaList;
